import { MantineProvider, Global } from "@mantine/core";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import { useSelector, shallowEqual } from "react-redux";
import Terms from "./pages/Terms";
import kraftig from "./fonts/soehne-kraftig.woff2";
import buch from "./fonts/soehne-buch.woff2";

export function CustomFonts() {
  return (
    <Global
      styles={[
        {
          "@font-face": {
            fontFamily: "Soehne",
            src: `url('${kraftig}') format("woff2")`,
            fontWeight: 600,
            fontStyle: "normal",
          },
        },
        {
          "@font-face": {
            fontFamily: "Soehne",
            src: `url('${buch}') format("woff2")`,
            fontWeight: 900,
            fontStyle: "normal",
          },
        },
      ]}
    />
  );
}

export default function Navigation() {
  const theme = useSelector((state) => state.theme, shallowEqual);

  return (
    <MantineProvider
      theme={{
        globalStyles: () => ({
          b: {
            fontWeight: 100,
          },
          p: {
            fontWeight: 800,
            marginTop: 0,
            marginBottom: 0,
          },
        }),
        colorScheme: theme,
        defaultRadius: "md",
        primaryColor: "indigo",
        fontFamily: "Soehne, sans-serif",
      }}
      withGlobalStyles
      withNormalizeCSS
    >
      <CustomFonts />
      <BrowserRouter>
        <Routes>
          <Route>
            <Route path="/" element={<Dashboard />} />
            <Route path="terms" element={<Terms />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </MantineProvider>
  );
}
